import Modal from "components/HOCS/Modal";
import { PrivateLockBlue } from "graphics/icons/BranchBar/PrivateLock";
import { isRootEffice } from "helpers/efficeHelpers";
import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  makeSelectPermissionsNode,
  makeSelectAncestorNode,
} from "slices/sharedSelectors";
import { selectAddPeopleModal, setAddPeopleModal } from "slices/textSlice";
import InvitePeopleMain from "./InvitePeopleMain/InvitePeopleMain";
import { NewPeopleList } from "./NewPeopleList/NewPeopleList";

const AddPeople = () => {
  const dispatch = useDispatch();
  const addPeopleModal = useSelector(selectAddPeopleModal);
  const selectPermissionsNode = useMemo(makeSelectPermissionsNode, []);
  const selectAncestorNode = useMemo(makeSelectAncestorNode, []);
  const permissionsNode = useSelector((state) =>
    selectPermissionsNode(state, addPeopleModal)
  );
  const ancestorNode = useSelector((state) =>
    selectAncestorNode(state, addPeopleModal)
  );

  if (addPeopleModal) {
    return (
      <Modal
        growth={false}
        noBackDropClick={false}
        lightBackDrop={true}
        header={
          <div className="add-people-header add-people-constrict">
            Add People to&nbsp;&nbsp;&nbsp;
            <span
              style={{
                position: "relative",
                bottom: "2px",
              }}
            >
              <PrivateLockBlue />
              &nbsp;
            </span>
            <span className="d-inline-block dotdotdot  font-extra-bold">
              {permissionsNode.content}
            </span>
          </div>
        }
        content={
          isRootEffice(permissionsNode) ? (
            <InvitePeopleMain currentPermissionsEffice={permissionsNode} />
          ) : (
            <div className="add-people-content">
              <NewPeopleList
                permBranch={permissionsNode}
                ancestorBranch={ancestorNode}
              />
            </div>
          )
        }
        onDismiss={() => {
          dispatch(setAddPeopleModal(null));
        }}
      />
    );
  } else {
    return null;
  }
};

export default AddPeople;
